export default __webpack_public_path__ + "acc3b75a0f0005c053f8758bdf067908.jpg";